<script>
  import { link } from "../util/anchor-link.js";
  import { LINK_HOME } from "../util/constants";
</script>

<a href={`/${LINK_HOME}`} use:link class="noselect">
  <div class="container noselect">bitframes</div>
</a>

<style>
  .container {
    --border-color: black;
    display: flex;
    justify-content: center;
    align-items: center;
    /* height: 32px; */
    /* width: 50px; */

    letter-spacing: 1px;
    -webkit-user-drag: none;
    font-weight: normal;

    cursor: pointer;
    font-size: 12px;
    padding: 0px 5px;
    /* margin-left: -5px; */
    position: relative;
    border-left: 1px solid black;
    box-shadow:
      0px 3px 0px var(--border-color),
      3px 0px 0px var(--border-color),
      3px 3px 0px var(--border-color),
      3px -1px 0px var(--border-color),
      0px -1px 0px var(--border-color);
  }
  .container::before {
    content: " ";

    /* border-top: 1px solid black; */
    /* border-bottom: 1px solid black; */
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
  }
  a {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    /* margin-left: -4px; */
    padding: 20px;
    padding-left: 20px;
    padding-right: 20px;
    /* background: yellow; */
    box-sizing: border-box;
    text-transform: uppercase;
    text-decoration: none;
  }
</style>
